export default "__VITE_ASSET__CLkmpsgK__"